import { memo } from "react";

import { Transition } from "@headlessui/react";
import { type MoneyV2 } from "@shopify/hydrogen-react/storefront-api-types";

import { CartDiscountView } from "@cart/CartDiscount/CartDiscount.view";
import {
  STOREFRONT_TRANSITION_EASING,
  STOREFRONT_TRANSITION_DURATION,
} from "@tablescape/constants";
import { tw } from "classnames";

type Props = {
  cartLineChanging: boolean;
  discountedTotalAmount: Partial<MoneyV2> | undefined;
  showDiscount: boolean;
  title?: string;
};

const styles = {
  transition: {
    className: tw(
      "grid",
      "transition-grid-rows",
      STOREFRONT_TRANSITION_EASING,
      STOREFRONT_TRANSITION_DURATION
    ),
    enterFrom: tw("grid-rows-collapse"),
    enterTo: tw("grid-rows-expand"),
    leaveFrom: tw("grid-rows-expand"),
    leaveTo: tw("grid-rows-collapse"),
  },
};

const CartDiscountBase = ({
  cartLineChanging,
  discountedTotalAmount,
  showDiscount,
  title,
}: Props) => {
  return (
    <Transition appear={false} show={showDiscount} {...styles.transition}>
      <CartDiscountView
        cartLineChanging={cartLineChanging}
        discountedTotalAmount={discountedTotalAmount}
        title={title}
      />
    </Transition>
  );
};

export const CartDiscount = memo(CartDiscountBase);
